import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzProgressModule } from 'ng-zorro-antd/progress';
 
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { CardLimitComponent } from './card-limit.component';
import { NzIconModule } from 'ng-zorro-antd/icon'; 

const COMPONENTS = [CardLimitComponent];

@NgModule({
  imports: [CommonModule, NzProgressModule,NzAvatarModule,NzIconModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CardLimitModule {}
